import { BASEBALL } from "../../../../../constants/identifiers";
import { ALL_BASEBALL_MARKETS, TOTAL_HOME_RUNS_OVER_UNDER_4_5, TOTAL_HOME_RUNS_OVER_UNDER_6_5 ,TOTAL_HOME_RUNS_UNDER_OVER_5_5,UNDER_OVER} from "../constants/marketTypes";


export function getMarketsByCode(marketCode, markets) {
    let marketsByCode = [];

    if (marketCode && markets && markets.length) {
        for (const element of markets) {

            if (marketCode.code === UNDER_OVER.code && (element.id.substring(0, 3) === TOTAL_HOME_RUNS_OVER_UNDER_4_5.code || element.id.substring(0, 3) === TOTAL_HOME_RUNS_UNDER_OVER_5_5.code || element.id.substring(0, 3) === TOTAL_HOME_RUNS_OVER_UNDER_6_5.code )) {
                marketsByCode.push(element);
            }
            // check if there are markets for the given code
            if (element.id.substring(0, marketCode.code.length) === marketCode.code) {
                marketsByCode.push(element);
            }
        }
        if (marketCode.code === UNDER_OVER.code && marketsByCode.length) {
            let marketsCodeAux = marketsByCode.filter((mks) => mks.id.substring(0, 3) === TOTAL_HOME_RUNS_OVER_UNDER_4_5.code);
            marketsCodeAux = marketsCodeAux.concat(marketsByCode.filter((mks) => mks.id.substring(0, 3) === TOTAL_HOME_RUNS_UNDER_OVER_5_5.code));
            marketsCodeAux = marketsCodeAux.concat(marketsByCode.filter((mks) => mks.id.substring(0, 3) === TOTAL_HOME_RUNS_OVER_UNDER_6_5.code));
            marketsByCode = marketsCodeAux;
        }
    }
    return marketsByCode;
}

export function getBBMarketByCode(code) {
    return ALL_BASEBALL_MARKETS.filter(market => market.code === code.toString())[0];
}

export function isBaseBall(eventType) {
    switch (eventType) {
        case BASEBALL:
            return true;
        default:
            return false;
    }
}

export function toSentenceCase(name){
    let arr = name.split(" ")
    for (var i = 0; i < arr.length; i++) {
        arr[i] = arr[i].charAt(0).toUpperCase() + arr[i].slice(1).toLowerCase();
    
    }
    const str2 = arr.join(" ")
    return str2;
}


// WEBPACK FOOTER //
// ./src/ui-modules/sports-book/modules/baseball/helpers/marketHelpers.js